/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/segment/css/definition/content/segment.css */
@layer segment.definition {
  @layer segment.definition.content.segment;
}

/* src/primitives/segment/css/definition/variations/aligned.css */
@layer segment.definition {
  @layer segment.definition.variations.aligned;
}

/* src/primitives/segment/css/definition/segment-definition.css */
@layer segment.definition;

/* src/primitives/segment/css/theme/segment-theme.css */
@layer segment.theme;

/* src/primitives/segment/css/segment.css */
